import { render } from "./FirstNotification.vue?vue&type=template&id=3469b324&scoped=true&ts=true"
import script from "./FirstNotification.vue?vue&type=script&lang=ts"
export * from "./FirstNotification.vue?vue&type=script&lang=ts"

import "./FirstNotification.vue?vue&type=style&index=0&id=3469b324&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3469b324"]])

export default __exports__